import { Box } from '@mui/material';
interface NoRowsOverlayProps {
  isAdmin: boolean;
}
export function NoRowsOverlay({ isAdmin }: NoRowsOverlayProps) {
  const noRowsText = isAdmin ? 'No Data' : 'No Assigned Commodities';
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}
    >
      {noRowsText}
    </Box>
  );
}
